import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';

@Component({
  selector: 'app-view-file-upload',
  templateUrl: './view-file-upload.component.html',
  styleUrls: ['./view-file-upload.component.scss']
})
export class ViewFileUploadComponent implements OnInit {
@Input() totalRecords:number = 0;
@Input() getFileUploadStandardProcessArray:any = [];
@Output() viewDownloadFile = new EventEmitter<{index:number, type:string, fileName: string}>();
@Output() deleteClick = new EventEmitter<void>();
isAccessRead:boolean = false;
isAccessReadWrite:boolean = false;
roleForFacility: boolean = false;

  constructor(private accessControlService: AccessControlService,private authService: AuthService) { }

  ngOnInit(): void {
    this.roleForFacility = this.authService.roleForFacility();
    const accessData = this.accessControlService.checkAccess( MenuItemsAccess.StandardProcessRead, MenuItemsAccess.StandardProcessReadWrite);
    this.isAccessRead = accessData.isAccessRead;
    this.isAccessReadWrite = accessData.isAccessReadWrite;
  }

  showDownloadDocument(index:any,type:any, fileName: any){
    this.viewDownloadFile.emit({ index, type, fileName });
  }

  DeleteDownloadDocument(unique_Id:any){
    this.deleteClick.emit(unique_Id);
  }

}
